<template>
  <div class="popup__layer active">
    <div class="popup__edit">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalBase',
  components: {}
};
</script>
